{
  "page": {
    "title": "Administrare",
    "tabs": {
      "users": "Utilizatori",
      "scraping": "Sarcini de extragere",
      "mortgage": "Credit ipotecar",
      "translations": "Traduceri"
    },
    "createUser": "Creează utilizator",
    "failedToLoadUsers": "Încărcarea utilizatorilor a eșuat",
    "userUpdated": "Utilizator actualizat cu succes",
    "userCreated": "Utilizator creat cu succes",
    "failedToSaveUser": "Salvarea utilizatorului a eșuat",
    "userDeleted": "Utilizatorul „{{username}}” a fost șters cu succes",
    "failedToDeleteUser": "Ștergerea utilizatorului a eșuat",
    "scrapingStarted": "Sarcina de extragere a fost pornită cu succes",
    "deleteUserTitle": "Șterge utilizatorul",
    "deleteUserMessage": "Sigur doriți să ștergeți utilizatorul „{{username}}”? Această acțiune nu poate fi anulată."
  },
  "userList": {
    "loading": "Se încarcă utilizatorii...",
    "noUsers": "Niciun utilizator găsit",
    "active": "Activ",
    "inactive": "Inactiv",
    "notificationsEnabled": "Notificări activate",
    "notificationsDisabled": "Notificări dezactivate",
    "created": "Creat: {{date}}",
    "createdColumn": "Creat",
    "never": "Niciodată",
    "username": "Nume utilizator",
    "email": "E-mail",
    "role": "Rol",
    "status": "Stare",
    "emailNotifications": "Notificări prin e-mail",
    "lastLogin": "Ultima conectare",
    "actions": "Acțiuni",
    "editUser": "Editează {{username}}",
    "deleteUser": "Șterge {{username}}",
    "editUserTooltip": "Editează utilizatorul",
    "deleteUserTooltip": "Șterge utilizatorul"
  },
  "userForm": {
    "editTitle": "Editează utilizatorul",
    "createTitle": "Creează un utilizator nou",
    "usernameLabel": "Nume utilizator",
    "usernameError": "Numele de utilizator trebuie să aibă cel puțin 3 caractere",
    "emailLabel": "E-mail",
    "emailError": "Este necesară o adresă de e-mail validă",
    "passwordLabel": "Parolă",
    "passwordEditLabel": "Parolă (lăsați gol pentru a păstra parola actuală)",
    "passwordRequired": "Parola este obligatorie pentru utilizatorii noi",
    "passwordLength": "Parola trebuie să aibă cel puțin 8 caractere",
    "passwordHelper": "Minimum 8 caractere",
    "roleLabel": "Rol",
    "roleUser": "Utilizator",
    "roleAdmin": "Administrator",
    "activeLabel": "Activ",
    "emailNotificationsLabel": "Notificări prin e-mail",
    "saving": "Se salvează...",
    "save": "Salvează"
  },
  "mortgage": {
    "title": "Setări implicite pentru simularea creditului ipotecar",
    "description": "Parametrii impliciți folosiți pentru a calcula simularea de accesibilitate a creditului ipotecar afișată pe paginile de detaliu ale anunțurilor. Orice valoare poate fi suprascrisă per anunț în simularea propriu-zisă.",
    "failedToLoad": "Încărcarea setărilor ipotecare a eșuat",
    "failedToSave": "Salvarea setărilor ipotecare a eșuat",
    "saved": "Setările ipotecare au fost actualizate cu succes",
    "saving": "Se salvează...",
    "save": "Salvează",
    "fields": {
      "min_down_payment_rate": "Avans minim (%)",
      "max_down_payment": "Avans maxim (CHF)",
      "annual_income": "Venitul anual al gospodăriei (CHF)",
      "interest_rate": "Rata dobânzii (%)",
      "term_years": "Perioadă fixă (ani)",
      "maintenance_rate": "Întreținere și cheltuieli (%)",
      "purchase_costs_rate": "Costuri de achiziție (%)",
      "amortization_target_ltv": "LTV țintă de amortizare (%)",
      "amortization_years": "Perioadă de amortizare (ani)",
      "stress_test_rate": "Rata testului de stres (%)",
      "max_effort_ratio": "Rata maximă de efort (%)"
    }
  },
  "translations": {
    "title": "Traduceri ale anunțurilor",
    "description": "Titlurile și descrierile scurte ale anunțurilor sunt traduse imediat la import; descrierile complete sunt traduse ulterior, la prima deschidere a anunțului.",
    "failedToLoad": "Încărcarea stării traducerii a eșuat",
    "failedToStart": "Pornirea retraducerii a eșuat",
    "started": "Retraducerea a început — aceasta rulează în fundal.",
    "provider": "Furnizor",
    "disabled": "dezactivat",
    "adsInScope": "Anunțuri vizate",
    "pending": "În așteptare",
    "failed": "Eșuate",
    "usage": "Utilizare furnizor: {{used}} / {{limit}} caractere",
    "refresh": "Reîmprospătează",
    "dropAndRetranslate": "Elimină și retraduce",
    "confirmTitle": "Elimină și retraduce anunțurile",
    "confirmMessage_one": "Această acțiune va șterge traducerea de titlu/descriere din cache pentru {{count}} anunț aflat în prezent în domeniu (activ, neexclus/neinteresat/cumpărat/retras) și îl va retraduce în fundal. Descrierea completă din cache rămâne neatinsă — aceasta se traduce ulterior, la următoarea deschidere a anunțului.",
    "confirmMessage_few": "Această acțiune va șterge traducerile de titlu/descriere din cache pentru cele {{count}} anunțuri aflate în prezent în domeniu (active, neexcluse/neinteresat/cumpărate/retrase) și le va retraduce în fundal. Descrierile complete din cache rămân neatinse — acestea se traduc ulterior, la următoarea deschidere a fiecărui anunț.",
    "confirmMessage_other": "Această acțiune va șterge traducerile de titlu/descriere din cache pentru cele {{count}} de anunțuri aflate în prezent în domeniu (active, neexcluse/neinteresat/cumpărate/retrase) și le va retraduce în fundal. Descrierile complete din cache rămân neatinse — acestea se traduc ulterior, la următoarea deschidere a fiecărui anunț.",
    "confirmMessageUsage": " Utilizare curentă a furnizorului: {{used}} / {{limit}} caractere."
  },
  "scraping": {
    "controls": {
      "automaticTitle": "Extragere automată",
      "loadingSchedule": "Se încarcă programul…",
      "enabled": "Activată",
      "disabled": "Dezactivată",
      "nextRun": "Următoarea execuție: {{date}}",
      "frequency": "Frecvență",
      "firstRunAt": "Prima execuție la",
      "firstRunHelper": "Setați data/ora primei extrageri. Execuțiile ulterioare urmează intervalul de frecvență de la această oră.",
      "manualTitle": "Controale de extragere manuală",
      "manualDescription": "Declanșați manual extragerea pentru un anumit site sau pentru toate site-urile.",
      "starting": "Se pornește...",
      "runNow": "Execută acum",
      "emailTitle": "Notificări prin e-mail",
      "sendNotificationTitle": "Trimite e-mail de notificare",
      "sendNotificationDescription": "Trimiteți manual un e-mail de notificare tuturor utilizatorilor abonați cu anunțurile noi și restante curente",
      "sending": "Se trimite...",
      "sendNow": "Trimite acum",
      "scrapers": {
        "all": {
          "label": "Toate site-urile",
          "description": "Execută extragerea pentru toate site-urile configurate"
        },
        "immobilier_ch": {
          "label": "Immobilier.ch",
          "description": "Platformă imobiliară elvețiană"
        },
        "homegate_ch": { "label": "Homegate.ch", "description": "Platformă imobiliară elvețiană" },
        "comparis_immobilier": {
          "label": "Comparis",
          "description": "Platformă elvețiană de comparare"
        },
        "properstar_ch": {
          "label": "Properstar.ch",
          "description": "Portal imobiliar internațional"
        },
        "anibis_ch": {
          "label": "Anibis.ch",
          "description": "Platformă elvețiană de anunțuri"
        },
        "immoscout24_ch": {
          "label": "ImmoScout24.ch",
          "description": "Platformă imobiliară elvețiană"
        },
        "newhome_ch": {
          "label": "Newhome.ch",
          "description": "Platformă imobiliară elvețiană"
        }
      }
    },
    "jobList": {
      "status": "Stare",
      "scraper": "Sursă",
      "all": "Toate",
      "running": "În curs",
      "completed": "Finalizată",
      "partial": "Parțială",
      "failed": "Eșuată",
      "refresh": "Reîmprospătează",
      "noJobs": "Nicio sarcină de extragere găsită",
      "started": "Început: {{date}}",
      "duration": "Durată: {{duration}}",
      "scraped": "Extrase: {{count}}",
      "imported": "Importate: {{count}}",
      "updated": "Actualizate: {{count}}",
      "retired": "Retrase: {{count}}",
      "id": "ID",
      "startedColumn": "Început",
      "durationColumn": "Durată",
      "scrapedColumn": "Extrase",
      "importedColumn": "Importate",
      "updatedColumn": "Actualizate",
      "retiredColumn": "Retrase",
      "duplicatesColumn": "Duplicate",
      "trigger": "Declanșator",
      "actions": "Acțiuni",
      "viewLogs": "Vezi jurnalele",
      "restartScraping": "Repornește extragerea",
      "allSites": "Toate site-urile"
    },
    "logViewer": {
      "title": "Jurnale de execuție a extragerii",
      "close": "Închide",
      "runDetails": "Detalii execuție",
      "runId": "ID execuție: {{id}}",
      "started": "Început: {{date}}",
      "searchPlaceholder": "Caută în jurnale...",
      "logLevel": "Nivel jurnal",
      "noLogsMatch": "Niciun jurnal nu corespunde filtrelor",
      "noLogsAvailable": "Niciun jurnal disponibil pentru această execuție",
      "showingLines_one": "Se afișează {{count}} linie",
      "showingLines_few": "Se afișează {{count}} linii",
      "showingLines_other": "Se afișează {{count}} de linii",
      "filtered": " (filtrat)"
    }
  }
}
